export type HighlightsState = Record<
  lvIdentifier,
  {
    highlights: Array<string>;
  }
>;
